import { useEffect } from "react";
import styles from "./Menu.module.scss";
import { IoMdClose } from "react-icons/io";
import MenuGroup from "./MenuGroup";
import useQuickMenu from "#hooks/quickMenu/useQuickMenu";

const Menu = ({ show, onClose }) => {
  const { menuItems } = useQuickMenu();

  // 메뉴 아이템을 카테고리별로 그룹화하고, order 순으로 정렬하는 함수
  const groupAndSortMenuItems = (items) => {
    const grouped = items.reduce((acc, item) => {
      const category =
        typeof item?.category === "string"
          ? item.category
          : item?.category?.label;

      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item);
      acc[category].sort((a, b) => a.order - b.order);
      return acc;
    }, {});

    return Object.entries(grouped).map(([category, items]) => ({
      category,
      items,
    }));
  };

  // 메뉴를 원하는 순서로 재정렬하는 함수
  const sortMenuByCategoryOrder = (menu, order) => {
    return menu.sort(
      (a, b) => order.indexOf(a.category) - order.indexOf(b.category)
    );
  };

  const groupedMenu = groupAndSortMenuItems(menuItems);
  const categoryOrder = ["상품", "행사 및 점포정보", "기타"];
  const sortedMenu = sortMenuByCategoryOrder(groupedMenu, categoryOrder);

  // 메뉴가 표시될 때 body의 overflow를 제어
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  return (
    <div className={`${styles.menu} ${show ? styles.show : ""}`}>
      <div className="z-50 flex flex-col h-full p-inner">
        <div className="flex justify-end pt-3">
          <button
            onClick={onClose}
            className="flex items-center justify-center w-12 h-12"
          >
            <IoMdClose className="text-3xl" />
          </button>
        </div>
        <div className="flex-auto overflow-y-auto">
          {sortedMenu.map(({ category, items }, index) => (
            <MenuGroup
              key={index}
              category={category}
              items={items}
              onClick={onClose}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Menu;
